export class FieldType {
  static Enum = {
    Signature: 'signature',
    Initials: 'initials',

    TextField: 'textinput',
    TextArea: 'textarea',
    CheckBox: 'checkbox',
    RadioButton: 'radiobutton',
    DropDown: 'dropdown',
  };
}
